import React from "react";
import { getMaterialMasterData } from "./api";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { masterMaterialsColumns } from "./MCSTables";
import SubTable from "./SubTable";
import { Box, TextField, Typography } from "@mui/material";
import { lightTable } from "../../../styles/muiProps";

export default function MaterialRecords() {
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    const func = async () => {
      const data = await getMaterialMasterData();
      console.log(data);
      setData(data);
    };
    func();
  }, []);

  const table = useMaterialReactTable({
    columns: masterMaterialsColumns,
    data,
    ...lightTable,

    enableExpanding: true,
    renderDetailPanel: ({ row }) => <SubTable row={row} />,
    // enableExpandAll: false, //hide expand all button in header

    muiTableBodyRowProps: ({ row, table }) => ({
      onClick: () => table.getRowModel().rows[row.index].toggleExpanded(),
      sx: {
        cursor: "pointer",
      },
    }),

    // displayColumnDefOptions: {
    //   "mrt-row-expand": {
    //     enableResizing: true, //allow resizing
    //     size: 20, //make the expand column wider
    //   },
    // },
  });
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ m: 1, mt: 0 }}>
        Material Records
      </Typography>
      <MaterialReactTable
        table={table}
        // columns={masterMaterialsColumns}
        // enableGrouping
        // enableColumnDragging={false}
        // // initialState={{ grouping: ["materialCode"] }}
        // data={data ?? []}
        // defaultColumn={{ minSize: 40 }}
        // renderTopToolbarCustomActions={({ table }) => {
        //   const selectedRows = table.getSelectedRowModel();

        //   const isDisabled = () => {
        //     if (selectedRows?.rows[0]) {
        //       return false;
        //     }
        //     return true;
        //   };

        //   return (
        //     <Box sx={{ display: "flex", gap: "1rem", p: "4px" }}>
        //       {/* <TextField placeholder="Filter" margin="dense" sx={{ p: 0 }} /> */}
        //       {/* <Button
        //           variant="contained"
        //           disabled={isDisabled()}
        //           onClick={() => {
        //             setOpenAddPoModal(true);
        //             setSelectedMrqMaterials(
        //               selectedRows.rows.map((r) => {
        //                 console.log(r.original);
        //                 return {
        //                   ...r.original,
        //                   //, id: r.original.id[0]
        //                 };
        //               })
        //             );
        //           }}
        //         >
        //           Add To PO
        //         </Button>
        //         <Button
        //           variant="contained"
        //           disabled={isDisabled()}
        //           onClick={() => {
        //             setSelectedMrqMaterials(
        //               selectedRows.rows.map((r) => {
        //                 return { ...r.original };
        //               })
        //             );
        //           }}
        //         >
        //           Create Bid valuation
        //         </Button> */}
        //     </Box>
        //   );
        // }}
      />
    </Box>
  );
}
